import { z } from 'zod'

import { FollowReplyScheme } from 'shared/api/common/schemas/flow/flow'

export const followReplySchemas = {
  getData: {
    query: z.undefined(),
    path: z.undefined(),
    response: FollowReplyScheme,
  },
  switch: {
    query: z.undefined(),
    path: z.undefined(),
    request: z.object({
      enabled: z.number(),
    }),
    response: FollowReplyScheme,
  },
  replaceFlow: {
    query: z.undefined(),
    path: z.undefined(),
    request: z.object({
      flow_ns: z.string(),
    }),
    response: FollowReplyScheme,
  },
  removeFlow: {
    query: z.undefined(),
    path: z.undefined(),
    request: z.undefined(),
    response: FollowReplyScheme,
  },
  updateDelay: {
    query: z.undefined(),
    path: z.undefined(),
    request: z.object({
      delay: z.number(),
    }),
    response: FollowReplyScheme,
  },
}
